'use client'

import React from 'react'
import Link from 'next/link'

import { Box, cn } from '@hanzo/ui'
import { Button, Carousel, CarouselContent, CarouselItem } from '@hanzo/ui/primitives'

import Login from './login'
import { LuxLogo } from '@luxfi/logo'
import Logo from '../logo'
import { legal } from '../../site-def/footer'

const LoginPanel: React.FC<{
  close: () => void
  className?: string
  reviews: { text: string, author: string, href: string }[]
}> = ({
  close,
  className = '',
  reviews
}) => {

    return (
      <Box className={cn('grid grid-cols-1 md:grid-cols-2', className)}>
        <Box className='hidden md:flex w-full h-full bg-[radial-gradient(circle_at_24.1%_68.8%_,_rgba(15,14,14,0)_,_rgba(9,9,9,99.4))] flex-row items-end justify-end overflow-y-auto min-h-screen'>
          <Box className='h-full w-full max-w-[750px] px-8 pt-0'>
            <Box className='h-full w-full max-w-[550px] mx-auto flex flex-col justify-between min-h-screen py-10'>
              <Button
                variant='ghost'
                onClick={close}
                className='w-fit !min-w-0 p-2'
              >
                <Logo size='md' variant='wordmark' />
              </Button>
              <Carousel
                // Autoplay is an option now, not a plugin — and it holds while the
                  // pointer is over the carousel or focus is inside it, which is
                  // what `stopOnInteraction` was asking for.
                  options={{ align: 'center', loop: true, autoplay: 5000 }}
                className='w-full'
              >
                <CarouselContent>
                  {reviews.map(({ text, author, href }, index) => (
                    <CarouselItem key={index}>
                      <Link href={href} className='flex flex-col gap-3 cursor-pointer'>
                        <p>“{text}“</p>
                        <Box tag="p" className='text-sm'>{author}</Box>
                      </Link>
                    </CarouselItem>
                  ))}
                </CarouselContent>
              </Carousel>
            </Box>
          </Box>
        </Box>
        <Box className='w-full h-full bg-background flex flex-row items-center'>
          <Box className='w-full max-w-[750px] relative flex flex-col items-center px-8 pt-0 text-center'>
            <Box className='relative h-full w-full max-w-[400px] mx-auto flex flex-col gap-4 items-center py-10'>
              <Button
                variant='ghost'
                onClick={close}
                className='block md:hidden absolute rounded-full p-2 left-0 h-auto hover:bg-background'
              >
                <LuxLogo variant='white' size={20} />
              </Button>
              <Login className='w-full max-w-sm' />
              <Box tag="p" className='text-sm opacity-50'>
                {legal.map(({ title, href }, index) => (
                  <React.Fragment key={href}>
                    {index > 0 && ' · '}
                    <Link href={href} className='underline'>{title}</Link>
                  </React.Fragment>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }

export default LoginPanel
